
/* @ngInject */
function SearchFilters2Controller($scope, $attrs, $stateParams, $location, $timeout, $anchorScroll, $window, $rootScope) {
    const vm = this;
    const MINIMUM_DISPLAYED_LIST_LENGTH = 7;
    let checkboxTimeout;

    vm.currentFilter = $scope.currentFilter;
    vm.currentFilterTypeId = vm.currentFilter.TypeId;
    vm.numbericCheckboxListOptions = [];

    // run on init
    function init() {
        getStaticNumericCheckboxList();
        updateFilterFromURL();

        if ($scope.last) {
            $rootScope.$broadcast('searchFiltersDirective.filtersLoaded');
        }
    }
    init();


    function updateFilterFromURL() {
        const currentFilter = vm.currentFilter;
        const values = $scope.getFilterURLValues(currentFilter)[0].values;

        if (currentFilter.InputOptions) {
            // loop through the checkbox options and set checked true where value is matched
            for (let i = 0; i < currentFilter.InputOptions.length; i++) {
                for (let j = 0; j < values.length; j++) {
                    if (currentFilter.InputOptions[i].DisplayName === values[j]) {
                        currentFilter.InputOptions[i].isChecked = true;
                        break;
                    }
                }
            }

            const optionsChecked = [];
            const optionsNotChecked = [];

            for (let k = 0; k < currentFilter.InputOptions.length; k++) {
                // js lint complained about a ternary that doesn't assign any result..
                if (currentFilter.InputOptions[k].isChecked) {
                    optionsChecked.push(currentFilter.InputOptions[k]);
                } else {
                    optionsNotChecked.push(currentFilter.InputOptions[k]);
                }
            }

            // concatenate checked and not checked, do not do this on numeric range inputs
            if (currentFilter.TypeId === 1) {
                currentFilter.InputOptions = optionsChecked.concat(optionsNotChecked);
                currentFilter.DisplayLimit = optionsChecked.length > MINIMUM_DISPLAYED_LIST_LENGTH ? optionsChecked.length : currentFilter.DisplayLimit;
            }
        }
    }

    function getStaticNumericCheckboxList() {
        const formatParts = vm.currentFilter.Format.split('|');
        const low = parseFloat(formatParts[0].split(':')[1]);
        const step = parseFloat(formatParts[1].split(':')[1]);
        // var round = parseInt(formatParts[2].split(":")[1], 10);

        vm.numbericCheckboxListOptions = [];
        let increment = low;
        for (let i = 0; i < vm.currentFilter.DisplayLimit; i++) {
            // First object
            if (i === 0) {
                vm.numbericCheckboxListOptions.push({
                    DisplayName: `Less than ${increment}`,
                    optionID: increment,
                    isChecked: false,
                    min: null,
                    max: increment,
                });
            }

            // Last object
            else if (i + 1 === vm.currentFilter.DisplayLimit) {
                vm.numbericCheckboxListOptions.push({
                    DisplayName: `Greater than ${increment}`,
                    optionID: increment,
                    isChecked: false,
                    min: increment,
                    max: null,
                });
            }

            // Middle objects
            else {
                vm.numbericCheckboxListOptions.push({
                    DisplayName: `${increment} - ${Math.floor((increment + step) * 100) / 100}`, // gets rid of extra decimal spaces
                    optionID: `${increment}_${step}`,
                    isChecked: false,
                    min: increment,
                    max: increment + step,
                });

                increment = parseFloat((increment + step).toFixed(2));
            }

            vm.currentFilter.InputOptions = vm.numbericCheckboxListOptions;
        }
    }

    vm.checkboxChanged = function () {
        $timeout.cancel(checkboxTimeout);

        checkboxTimeout = $timeout(() => {
            $scope.processFilter();
        }, 500);
    };
}

export default function SearchFilters2() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productsearch/searchFilters/templates/numeric-checkbox.html',
        controller: SearchFilters2Controller,
        controllerAs: 'searchFilter',
    };
}




// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productsearch/searchFilters/directives/searchFilterNumericCheckbox.directive.js